// Tab-level access for team members (admins always see everything).
export const MEMBER_HOME = "mydeals";

export const grantsFor = (user, M, dealName) => {
  const rows = user?.access?.deals || [];
  const name = dealName || M?.dealName || "";
  return rows.filter((g) => (g.dealKey && g.dealKey === M?.dealKey) || (g.dealName && name && g.dealName === name));
};

// null = unrestricted; otherwise the list of page ids the member may open for the current deal.
export const allowedTabs = (user, M, dealName) => {
  if (!user || user.role === "admin" || user.access?.admin) return null;
  const g = grantsFor(user, M, dealName);
  if (g.some((x) => x.all)) return null;
  return [MEMBER_HOME, ...new Set(g.flatMap((x) => x.tabs || []))];
};

export const canSee = (allowed, id) => !allowed || allowed.includes(id);
